import { Controller } from "@hotwired/stimulus"
import { getStatusPillClass, formatDateISO, formatDateDisplay } from "../utils/calendar_constants"

// Manages the day view of the calendar
export default class extends Controller {
  static targets = ["title", "events"]
  static values = {
    events: Array
  }
  
  connect() {
    this.currentDay = new Date()
    this.render()
  }
  
  previousDay() {
    this.currentDay.setDate(this.currentDay.getDate() - 1)
    this.render()
  }
  
  nextDay() {
    this.currentDay.setDate(this.currentDay.getDate() + 1)
    this.render()
  }
  
  today() {
    this.currentDay = new Date()
    this.render()
  }
  
  render() {
    // Update title
    this.titleTarget.textContent = formatDateDisplay(this.currentDay)
    
    // Filter events for this day
    const iso = formatDateISO(this.currentDay)
    const todaysEvents = this.eventsValue.filter(e => 
      (e.event_date || '').slice(0, 10) === iso
    )
    
    // Render events
    if (todaysEvents.length === 0) {
      this.eventsTarget.innerHTML = '<div class="bz-cal-dayrow__empty">No events for this day</div>'
      return
    }

    this.eventsTarget.innerHTML = todaysEvents.map(e => this.renderEvent(e)).join('')
  }

  renderEvent(event) {
    const status = event.status_display || ''
    const pillClass = getStatusPillClass(status)
    const client = event.client?.name || 'No client'

    return `
      <div class="bz-cal-dayrow event-hover-tooltip" data-event-id="${event.id}">
        <div class="bz-cal-dayrow__main">
          <div class="bz-cal-dayrow__name">${event.name || 'Untitled Event'}</div>
          <div class="bz-pill ${pillClass}" style="margin-top:6px;"><span class="bz-dot"></span>${status}</div>
        </div>
        <div class="bz-cal-dayrow__actions">
          <button class="day-view-status-btn bz-cal-link" data-event-id="${event.id}">View Status</button>
          <a href="/events/${event.id}" class="bz-cal-link">View Event</a>
        </div>

        <!-- Custom Hover Tooltip -->
        <div class="event-tooltip hidden">
          <div>${status}</div>
          <div class="event-tooltip__sub">${client}</div>
          <div class="event-tooltip__arrow"></div>
        </div>
      </div>
    `
  }
  
  // Handle status button clicks
  handleStatusClick(event) {
    if (event.target.classList.contains('day-view-status-btn')) {
      event.preventDefault()
      const eventId = event.target.getAttribute('data-event-id')
      const evt = this.eventsValue.find(ev => String(ev.id) === String(eventId))
      if (!evt) return
      
      // Dispatch event for status modal
      this.dispatch('show-status', { 
        detail: { 
          eventId, 
          eventName: evt.name || 'Event',
          eventStatus: evt.status_display || ''
        } 
      })
    }
  }
}

